(function () {
  'use strict';

  var module = angular.module('uwAgenda.global');
  module.controller('PagebarController', [
    '$rootScope',
    'SharedAgendaService',
    'ViewsService',
    '$state',
    PagebarControllerFn,
  ]);

  /* page bar controller */
  function PagebarControllerFn(
      $rootScope, 
      SharedAgendaService,
      ViewsService,
      $state) {
    /* jshint validthis:true */
    var vm = this;

    // show/hide toolbar
    vm.show = true;
    vm.currentViewId = null;
    vm.isRingphoneOperator = false;

    activate();

    /* load work */
    function activate() {
      // don't show "Views" dropdown for RP Operator Admin & Operator Restricted
      vm.isRingphoneOperator = $rootScope.isRingfoonOperator;
      
      if ($rootScope.isRingfoon) {
        return;
      }      
      
      // no need to display shared agenda toolbar, if user has only access to his own agenda
      if (
        SharedAgendaService.data.agendas.length === 1 &&
        SharedAgendaService.data.currentAgenda.owner.id === SharedAgendaService.getLoggedInUserData().id
      ) {
        vm.show = false;
      } //if
    } // activate

    vm.openCurrentViewDetail = function() {
        var currentView = ViewsService.getCurrentView();
        if (currentView) {
            $state.go('Home.Views', { id: currentView.id });
        } else {
            $state.go('Home.Views');
        }
    };

    vm.currentUserIsRingphoneAdmin = () => SharedAgendaService.currentUserIsRingphoneAdmin();
  }
})();
